import * as React from 'react';
import { useSelector } from 'react-redux';

import { Preloader } from '../Preloader';
import { WrapContainer } from '../WrapContainer';
import { ResultsEmptyForAuthorizationContainer } from '../../containers/ResultsEmptyForAuthorizationContainer';
import { ResultsEmptyContainer } from '../../containers/ResultsEmpty';
import { selectResults } from '../../selectors';
import { EGetFavoriteEntitiesStatus, IResultsState } from '../../types/results';

import * as styles from './styles.css';

interface IResultsMobile {
  results: IResultsState;
  isFavoritesForAuthorizationEnabled: boolean;
  isExperimentEnabled?: boolean;
  children?: React.ReactNode;
}

export const ResultsMobile: React.FC<IResultsMobile> = ({
  results,
  isFavoritesForAuthorizationEnabled,
  isExperimentEnabled,
  children,
}) => {
  const { status, favoriteEntities } = results;

  const { hasMore } = useSelector(selectResults);

  if (favoriteEntities.length === 0) {
    return <ResultsEmptyContainer isExperimentEnabled={isExperimentEnabled} />;
  }

  if (isFavoritesForAuthorizationEnabled) {
    return <ResultsEmptyForAuthorizationContainer />;
  }

  if (isExperimentEnabled && !hasMore) {
    return (
      <WrapContainer>
        <div className={styles['container']}>
          {children}
          {[EGetFavoriteEntitiesStatus.Loading, EGetFavoriteEntitiesStatus.NextPageLoading].includes(status) && (
            <div key="preloader" className={styles['preloader']}>
              <Preloader size={64} />
            </div>
          )}
        </div>
      </WrapContainer>
    );
  }

  return (
    <div className={styles['container']}>
      {children}
      {[EGetFavoriteEntitiesStatus.Loading, EGetFavoriteEntitiesStatus.NextPageLoading].includes(status) && (
        <div key="preloader" className={styles['preloader']}>
          <Preloader size={64} />
        </div>
      )}
    </div>
  );
};
